import BarChartCompletion from './BarChartCompletion';
import PieChartCompletion from './PieChartCompletion';

const MultiChartCompletionDashboard = ({ data }) => {
  if (data?.sections?.length === 0) return null;

  const transformedData = {
    sections: (data?.sections ?? []).map((item) => {
      const sectionNumber = item.name.split('-').pop().trim();
      return {
        ...item,
        sectionLabel: `Section ${sectionNumber}`,
      };
    }),
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        alignItems: 'center',
      }}
    >
      <BarChartCompletion data={transformedData} />
      <PieChartCompletion data={transformedData} />
    </div>
  );
};

export default MultiChartCompletionDashboard;
